// extracted by mini-css-extract-plugin
module.exports = {"no_plan_found":"no-plan-found_no_plan_found__4zyUx","mobile_btn":"no-plan-found_mobile_btn__oBuot","primary_btn":"no-plan-found_primary_btn__OEVrI"};